<template>
  <span class="has-text-weight-bold" :class="presenter.class">{{ presenter.label }}</span>
</template>

<script>
export default {
  computed: {
    presenter () {
      const presenter = {}
      if (this.transfer.status === 'approved') {
        presenter.class = 'has-text-success'
        presenter.label = 'Approved'
      } else if (this.transfer.status === 'archived') {
        presenter.class = 'has-text-grey-light'
        presenter.label = 'Archived'
      } else {
        presenter.class = 'has-text-warning'
        presenter.label = 'Pending'
      }
      return presenter
    }
  },
  props: {
    transfer: {
      type: Object,
      required: true
    }
  }
}
</script>
